import { useEffect, useState } from "react";
import { useCookies } from "react-cookie";
import { BrowserRouter, Redirect, Route, Switch } from "react-router-dom";
import Auth from "./components/route/Auth";
import Private from "./components/route/Private";
import Bab from "./pages/contents/babs/Bab";
import ComposeBab from "./pages/contents/babs/ComposeBab";
import ComposeContent from "./pages/contents/ComposeContent";
import Content from "./pages/contents/Content";
import DeepRead from "./pages/deep-read/DeepRead";
import ComposeDeepRead from "./pages/deep-read/ComposeDeepRead";
import DeepReadBab from "./pages/deep-read/babs/DeepReadBab";
import ComposeDeepReadBab from "./pages/deep-read/babs/ComposeDeepReadBab";
import DeepReadBook from "./pages/deep-read/Book";
import ComposeBook from "./pages/deep-read/ComposeBook";
import Dashboard from "./pages/dashboards/Dashboard";
import Login from "./pages/Login";
import service from "./service";
import Layout from "./components/Layout";
import UserDetail from "./pages/UserDetail";
import ActiveUser from "./pages/stats/ActiveUser";
import TopBook from "./pages/stats/TopBook";
import TopCategory from "./pages/stats/TopCategory";
import Course from "./pages/course/Course";
import ComposeCourse from "./pages/course/ComposeCourse";
import Category from "./pages/category/Category";
import Subject from "./pages/course/subject/Subject";
import ComposeSubject from "./pages/course/subject/ComposeSubject";
import Bank from "./pages/banks/Bank";
import Order from "./pages/order/Order";
import Config from "./pages/config/Config";
import Sync from "./pages/Sync";
import Review from "./pages/review/Review";
import SubpageLayout from "./components/SubpageLayout";
import Mentor from "./pages/mentors/Mentor";
import LandingPageList from "./pages/landing-page/LandingPage";
import ComposeLandingPage from "./pages/landing-page/ComposeLandingPage";
import MetaCapi from "./pages/meta-capi/MetaCapi";
import Users from "./pages/users/Users";
import UserView from "./pages/users/UserView";
import Affiliate from "./pages/affiliate/Affiliate";

const ContentGroup = () => {
  return (
    <Switch>
      <Route path="/content/" exact>
        <Content />
      </Route>
      <Route path="/content/edit/:id">
        <ComposeContent editMode={true} />
      </Route>
      <Route path="/content/bab/:id">
        <ComposeBab editMode={true} />
      </Route>
      <Route path="/content/add">
        <ComposeContent />
      </Route>
      <Route path="/content/:id/bab/add">
        <ComposeBab />
      </Route>
      <Route path="/content/:id/bab">
        <Bab />
      </Route>
    </Switch>
  );
};

const StatsGroup = () => {
  const items = [
    { title: "User Aktif", to: "/stats/active-user" },
    { title: "Data Baca User", to: "/stats/book" },
    { title: "Buku", to: "/stats/category" },
  ];
  return (
    <SubpageLayout title="Statistik" items={items}>
      <Switch>
        <Route path="/stats/active-user">
          <ActiveUser />
        </Route>
        <Route path="/stats/book">
          <TopBook />
        </Route>
        <Route path="/stats/category">
          <TopCategory />
        </Route>
      </Switch>
    </SubpageLayout>
  );
};

const SettingsGroup = () => {
  const items = [
    { title: "General", to: "/settings/config" },
    { title: "Bank", to: "/settings/bank" },
    { title: "Mentor", to: "/settings/mentor" },
    { title: "Meta CAPI", to: "/settings/meta-capi" },
  ];
  return (
    <SubpageLayout title="Settings" items={items}>
      <Switch>
        <Route path="/settings/config">
          <Config />
        </Route>
        <Route path="/settings/bank">
          <Bank />
        </Route>
        <Route path="/settings/mentor">
          <Mentor />
        </Route>
        <Route path="/settings/meta-capi">
          <MetaCapi />
        </Route>
      </Switch>
    </SubpageLayout>
  );
};

const CourseGroup = () => {
  return (
    <Switch>
      <Route path="/course/" exact>
        <Course />
      </Route>
      <Route path="/course/add" exact>
        <ComposeCourse />
      </Route>
      <Route path="/course/edit/:id" exact>
        <ComposeCourse editMode={true} />
      </Route>
      <Route path="/course/:id/subject/add">
        <ComposeSubject />
      </Route>
      <Route path="/course/:parent/subject/:id/edit">
        <ComposeSubject editMode={true} />
      </Route>
      <Route path="/course/:parent/subject/:id/add">
        <ComposeSubject inParent={true} />
      </Route>
      <Route path="/course/:id/subject">
        <Subject />
      </Route>
    </Switch>
  );
};

const PrivateGroup = () => {
  return (
    <Layout>
      <Switch>
        <Private path="/category" role={["super"]}>
          <Category />
        </Private>
        <Private path="/content" role={["super"]}>
          <ContentGroup />
        </Private>
        <Private path="/deep-read" role={["super"]}>
          <Switch>
            <Route path="/deep-read/" exact>
              <DeepRead />
            </Route>
            <Route path="/deep-read/add" exact>
              <ComposeDeepRead />
            </Route>
            <Route path="/deep-read/edit/:id">
              <ComposeDeepRead editMode={true} />
            </Route>
            <Route path="/deep-read/:id/book" exact>
              <DeepReadBook />
            </Route>
            <Route path="/deep-read/:id/book/add">
              <ComposeBook />
            </Route>
            <Route path="/deep-read/:id/book/:bookId/edit">
              <ComposeBook editMode />
            </Route>
            <Route path="/deep-read/:id/book/:bookId/ring" exact>
              <DeepReadBab />
            </Route>
            <Route path="/deep-read/:id/book/:bookId/ring/add">
              <ComposeDeepReadBab />
            </Route>
            <Route path="/deep-read/ring/:id">
              <ComposeDeepReadBab editMode={true} />
            </Route>
          </Switch>
        </Private>
        <Private path="/stats" role={["super"]} exact>
          <Redirect to="/stats/active-user" />
        </Private>
        <Private path="/stats" role={["super"]}>
          <StatsGroup />
        </Private>
        <Private path="/settings" role={["super"]} exact>
          <Redirect to="/settings/config" />
        </Private>
        <Private path="/settings" role={["super"]}>
          <SettingsGroup />
        </Private>
        <Private path="/order" role={["super"]}>
          <Order />
        </Private>
        <Private path="/affiliate" role={["super"]}>
          <Affiliate />
        </Private>
        <Private path="/users" exact role={["super"]}>
          <Users />
        </Private>
        <Private path="/users/:id" role={["super"]}>
          <UserView />
        </Private>

        <Private path="/review" role={["super"]}>
          <Review />
        </Private>
        <Private path="/landing-page" role={["super"]}>
          <Switch>
            <Route path="/landing-page/" exact>
              <LandingPageList />
            </Route>
            <Route path="/landing-page/add" exact>
              <ComposeLandingPage />
            </Route>
            <Route path="/landing-page/edit/:id">
              <ComposeLandingPage editMode={true} />
            </Route>
          </Switch>
        </Private>
        <Private path="/course" role={["super"]}>
          <CourseGroup />
        </Private>
        <Private path="/read-logs/:id" role={["super"]}>
          <UserDetail />
        </Private>
        <Private path="/" exact>
          <Dashboard />
        </Private>
      </Switch>
    </Layout>
  );
};

export default function App() {
  const [cookies] = useCookies();
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    // Auth via httpOnly admin_token (withCredentials)
    setLoading(false);
  }, [cookies.admin_logged_in, cookies.token]);

  if (loading) return null;
  return (
    <BrowserRouter>
      <Switch>
        <Auth path="/login">
          <Login />
        </Auth>
        <Route path="/">
          <PrivateGroup />
        </Route>
      </Switch>
    </BrowserRouter>
  );
}
